__turbopack_context__.v({
  "action": "ContactFormSuccessEditorial-module__T6G1Kq__action",
  "container": "ContactFormSuccessEditorial-module__T6G1Kq__container",
  "copy": "ContactFormSuccessEditorial-module__T6G1Kq__copy",
  "divider": "ContactFormSuccessEditorial-module__T6G1Kq__divider",
  "eyebrow": "ContactFormSuccessEditorial-module__T6G1Kq__eyebrow",
  "message": "ContactFormSuccessEditorial-module__T6G1Kq__message",
  "sendAnother": "ContactFormSuccessEditorial-module__T6G1Kq__sendAnother",
  "title": "ContactFormSuccessEditorial-module__T6G1Kq__title",
});
